'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

// helper module to isolate real storage of LinkSoft global settings.
exports.default = function () {
    if (_typeof(window.linksoft) !== 'object') {
        window.linksoft = {};
    }
    return window.linksoft;
};


//////////////////
// WEBPACK FOOTER
// ./~/linksoft/core/config.js
// module id = 231
// module chunks = 0 1